import { render } from "./hallOfGoldMiners.vue?vue&type=template&id=f70742dc&lang=true"
import script from "./hallOfGoldMiners.vue?vue&type=script&lang=js"
export * from "./hallOfGoldMiners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__